/**
 * Bundled Ed25519 PUBLIC key (base64url, raw) used to verify unlock codes.
 * Generate a real one with `npm run keygen` and paste the PUBLIC key here.
 *
 * The matching PRIVATE key is a SECRET that lives ONLY in the mobile app / your
 * token-issuing tool — never in this web bundle, never in git.
 */
// PRODUCTION key — rotated 2026-08-11 after the previous DEV key's private seed
// was committed to git history (burned). The matching private seed lives only in
// the mobile app's build config (local.properties `license.web.seed`), never in
// this bundle and never in git.
export const LICENSE_PUBLIC_KEY: string = "TexN-Ss7D-GntcfBoHQpWpkCVF7mcPWrO-adOjEqiDc";

export const hasRealKey = (): boolean =>
  LICENSE_PUBLIC_KEY !== "REPLACE_WITH_PUBLIC_KEY" && LICENSE_PUBLIC_KEY.length > 0;

/**
 * Deployed license-registry Worker URL (see /worker). Enables the "one active
 * browser per purchase" check. Leave empty to disable the online check entirely
 * (offline browser-binding still applies). No trailing slash.
 */
export const LICENSE_API_URL: string = "https://carspend-license.lucaiuli.workers.dev";
